import styled from "styled-components";

// La licencia no tiene imagen ni cantidad: se configura con terapeutas y anos.
const gridTemplate = `
  display: grid;
  grid-template-columns: 1fr 120px 120px 100px;
  align-items: center;
  gap: 10px;
`;

export const GroupContainer = styled.div`
  margin-bottom: 25px;
  width: 100%;
`;
export const ColumnLabels = styled.div`
  ${gridTemplate}
  padding: 0 20px 6px;
`;
export const ColumnLabel = styled.span`
  font-size: 12px;
  color: #777;
  text-align: center;
`;
export const GroupHeader = styled.div`
  ${gridTemplate}
  padding: 15px 20px;
  border-radius: 6px 6px 0 0;
  color: #fff;
  background-color: #1c1c1c;
`;
export const GroupTitle = styled.h3`
  font-size: 17px;
  font-weight: 600;
`;
export const HeaderValue = styled.span`
  font-size: 15px;
  text-align: center;
`;
export const RowContainer = styled.div`
  ${gridTemplate}
  padding: 15px 20px;
  border-radius: 0 0 6px 6px;
  background-color: #fff;
`;
export const RowInfo = styled.div`
  display: flex;
  flex-direction: column;
`;
export const RowName = styled.span`
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #222;
`;
export const Feature = styled.span`
  padding-left: 12px;
  font-size: 12.5px;
  line-height: 1.6;
  color: #555;
  text-indent: -12px;
  &:before {
    content: "• ";
  }
`;
export const RowValue = styled.span`
  font-size: 14px;
  color: #222;
  text-align: center;
`;
